<template>
  <div class="map-data">
    <div class="font20" @click="toDetail({name,code})" style="cursor:pointer;">{{name?name:code}}</div>
    <el-table :data="table" stripe v-loading="loading" style="width: 100%">
      <el-table-column width="80">
        <template slot-scope="scope">
          <div v-if="scope.$index == 0">
            <img src="../../../assets/images/g.png" style="display:inline-block;margin-right:3px;">
            <span style="color:#9F9F9F;">+</span>
            <img src="../../../assets/images/q.png" style="display:inline-block;margin-left:3px;">
          </div>
          <div v-if="scope.$index == 1">
            <img src="../../../assets/images/g.png" style="display:inline-block;margin-right:3px;">
            <span style="color:#9F9F9F;">个人</span>
          </div>
          <div v-if="scope.$index == 2">
            <img src="../../../assets/images/q.png" style="display:inline-block;margin-right:3px;">
            <span style="color:#9F9F9F;">企业</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user" label=" 消费数用户 (个) " align="center" width="150">
        <template slot-scope="scope">
            {{format(scope.row.user)}}
        </template>
      </el-table-column>
      <el-table-column prop="card" label="消费卡数 (张) " align="center" width="150">
        <template slot-scope="scope">
            {{format(scope.row.card)}}
        </template>
      </el-table-column>
      <el-table-column prop="num" label="消费笔数 (次) " align="center" width="150">
        <template slot-scope="scope">
            {{format(scope.row.num)}}
        </template>
      </el-table-column>
      <el-table-column prop="litter" label="消费吨数 (吨) " align="center" width="150">
        <template slot-scope="scope">
            {{format(scope.row.litter)}}
        </template>
      </el-table-column>
      <el-table-column prop="mount" label="消费金额 (万元) " align="center" width="150">
        <template slot-scope="scope">
            {{format(scope.row.mount)}}
        </template>
      </el-table-column>
      <el-table-column prop="etpref" label="产生优惠额 (万元) " align="center" width="150">
        <template slot-scope="scope">
            {{format(scope.row.etpref)}}
        </template>
      </el-table-column>
      <el-table-column prop="ommuse" label="优惠加油额 (万元) " align="center" width="150">
        <template slot-scope="scope">
            {{format(scope.row.ommuse)}}
        </template>
      </el-table-column>
      <el-table-column prop="echarge" label="充值金额 (万元) " align="center" width="150" v-if="isShow">
        <template slot-scope="scope">
            {{format(scope.row.echarge)}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    dataAll: {
      type: [Array, Object]
    },
    toDetail: {
      type: Function,
      default: () => {}
    },
    name: {
      type: String,
      default: '合计'
    },
    isShow:{
      type:Boolean,
      default:false
    },
    code: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      table: []
    }
  },
  mounted() {
    if (this.dataAll) {
      this.table = [...this.initData(this.dataAll)]
    }
  },
  watch: {
    dataAll: function(value, oldValue) {
      if (value) {
        this.table = [...this.initData(value)]
      }
    }
  },
  methods: {
    format(num) {
      if(num==undefined||num==null||num=='')return 0;
      var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
          return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
              return $1+",";
            });
      })
      return res;
    },
    initData(data) {
      let all = {}
      let user = {}
      let comp = {}
      all.user = data.toatlUser
      user.user = data.peopleUser
      comp.user = data.companyUser

      all.card = data.toatlCard
      user.card = data.peopleCard
      comp.card = data.companyCard

      all.num = data.toatlNumber //个人消费笔数
      user.num = data.peopleNumber //企业消笔数
      comp.num = data.companyNumber //总共消费笔数

      user.litter = data.peoplelitter //个人消费升数
      comp.litter = data.companlitter //企业消升数
      all.litter = data.toatllitter //总共消费升数

      user.mount = data.peopleAmount //个人消费金额
      comp.mount = data.companAmount //企业消金额
      all.mount = data.toatlAmount //总共消费金额

      user.etpref = data.peopleGetpref //个人产生优惠额 返利
      comp.etpref = data.companGetpref //企业产生优惠额
      all.etpref = data.toatlGetpref //总共产生优惠额

      user.ommuse = data.peopleGetprefCommuse //个人产生优惠加油额 返利消费
      comp.ommuse = data.companGetprefCommuse //企业产生优加油惠额
      all.ommuse = data.toatlGetprefCommuse //总共产生优惠加油额

      user.echarge = data.peopleRecharge //个人充值金额
      comp.echarge = data.companRecharge //企业充值金额
      all.echarge = data.toatlRecharge //中共充值金额
      return [all, user, comp]
    }
  }
}
</script>